import IconFries from 'components/icons/fries';

export const UnauthenticatedEmptyStateImage = IconFries;
export const ErrorEmptyStateImage = IconFries;
